import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

if (!process.env.REACT_APP_API_URL) {
  throw new Error('REACT_APP_API_URL environment variable is not defined');
}

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 
// zzrebuild z07edc6f5 1791134387.686586
